import Api from './index';

const getTeachingOrderById = (teachingOrderId, params) =>
  Api.get(`users/me/teaching-orders/${teachingOrderId}`, { params });

const getTeachingOrders = params => Api.get(`users/me/teaching-orders`, { params });

const updateTeachingOrder = (teachingOrderId, options) =>
  Api.put(`users/me/teaching-orders/${teachingOrderId}`, options);

const removeTeachingOrder = (teachingOrderId, params) =>
  Api.destroy(`users/me/teaching-orders/${teachingOrderId}`, { params });

const createTeachingOrder = data => Api.post(`users/me/teaching-orders`, { data });

export {
  getTeachingOrderById,
  getTeachingOrders,
  updateTeachingOrder,
  removeTeachingOrder,
  createTeachingOrder
};
